import React, { useEffect, useState } from 'react';
import { fetchgetEfficiencyChange } from '../../../Service/APIService';
import Auth from '../../../shared/Auth';
import TableHeader from '../../Custom/TableHeader';
import ChartLoader from '../../Loaders/ChartLoader';

const ChartEfficiencyChange = ({ type, id }) => {
  const [isLoading, setLoading] = useState(true);
  const [data, setData] = useState([]);

  const bindData = () => {
    setLoading(true);
    fetchgetEfficiencyChange(type, id).then((response) => {
      setLoading(false);
      const { statusCode, result } = response.data;
      setData(statusCode === 200 ? result : []);
    });
  };
  useEffect(() => {
    async function fetchData() {
      const checkToken = await Auth();
      if (checkToken) {
        bindData();
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [type, id]);

  if (isLoading) {
    return <ChartLoader height="150" width="600" />;
  }
  return (
    <TableHeader title={'Efficiency Change'}>
      <table className="tbl">
        <thead>
          <tr>
            <th>Time of Reading</th>
            <th>Efficiency (%)</th>
            <th>Change (%)</th>
          </tr>
        </thead>
        <tbody>
          {data.map((losses, i) => (
            <tr key={i}>
              <td width="50%">{`${losses.interval} ago`}</td>
              <td width="25%">{losses.efficiency}</td>
              <td width="25%">{losses.changePercent}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </TableHeader>
  );
};
export default ChartEfficiencyChange;
